import { useEffect, useState } from 'react'
import { useEditorContext } from '@/scenes/engine'

import HistoryControls from '@/components/HistoryControls'
import { useSelector } from 'react-redux'
import { selectDisableEditorState } from '@/store/slices/editor/selector'

function History() {
  const editor = useEditorContext().editor
  const disableEditorState = useSelector(selectDisableEditorState)
  const isDisabled = disableEditorState.history === 'disabled'

  const [historyStatus, setHistoryStatus] = useState({ hasUndo: false, hasRedo: false })
  useEffect(() => {
    const handleHistoryChange = (data: any) => {
      setHistoryStatus({ ...historyStatus, hasUndo: data.hasUndo, hasRedo: data.hasRedo })
    }
    if (editor) {
      setHistoryStatus({
        hasUndo: editor.handlers.transactionHandler.hasUndo(),
        hasRedo: editor.handlers.transactionHandler.hasRedo(),
      })
      editor.on('history:changed', handleHistoryChange)
    }
    return () => {
      if (editor) {
        editor.off('history:changed', handleHistoryChange)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editor])

  return (
    <HistoryControls
      hasUndo={historyStatus.hasUndo}
      hasRedo={historyStatus.hasRedo}
      disabled={isDisabled}
      onUndo={() => editor.undo()}
      onRedo={() => editor.redo()}
    />
  )
}
export default History
